<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      ref="searchBox"
      @sub="sub"
      title="筛选"
      :moreSearchVisible="false"
      permpisionsQuery
    >
      <div slot="waitDeal" slot-scope="prop">
        <el-checkbox label="待我处理" name="type" v-model="prop.form.waitDeal" />
      </div>
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
  getDepartmentAllList,
} from 'api';
import {
  // manageCostType,
  queryManagerTypes,
} from 'api/cost';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        payTypeNameOptions: [], // 费用类型
        stateOptions: [], // 状态
        orgIdOptions: [], // 费用归属
        form: [
          { // 快速过滤
            label: '',
            value: 'waitDeal',
            default: false,
            slot: true,
            class: 'next-search-btn',
          },
          {
            label: '',
            value: 'state',
            type: 'radio',
            default: -1,
            class: 'especial-radio-group',
            normalFormNotCount: true,
            onChangeRadio: () => {
              this.$refs.searchBox.sub();
            },
          },
          { // 报销日期
            label: '报销日期',
            value: 'Time',
            type: 'date',
            placeholder: '请选择报销日期',
            attr: {
              type: 'daterange',
            },
          },
          { // 申请人
            label: '申请人',
            value: 'applyUserName',
            type: 'input',
            placeholder: '请输入申请人',
          },
          {
            label: '费用类型',
            value: 'payTypeName',
            type: 'select',
            default: 0,
          },
          { // 收款人
            label: '收款人',
            value: 'receName',
            type: 'input',
            placeholder: '请输入收款人',
          },
          { // 报销金额
            label: '报销金额',
            value: 'Amt',
            type: 'inputrange',
            placeholder: '请输入报销金额',
          },
        ],
      },
    };
  },
  watch: {
    '$route.query.state': function () {
      this.jumpHereSearchState();
    },
  },
  methods: {

    jumpHereSearchState () {
      if (this.$route.query.state) {
        this.$refs.searchBox.setVal('state', this.$route.query.state);
      } else {
        this.$refs.searchBox.setVal('state', '-1');
      }
    },

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {

      // 申请时间
      if (searchBoxData.Time && searchBoxData.Time.length > 0) {
        searchBoxData.startTime = this.formatDate(searchBoxData.Time[0]);
        searchBoxData.endTime = this.formatDate(searchBoxData.Time[1]);
        delete searchBoxData.Time;
      }
      // 报销金额
      if (searchBoxData.Amt && searchBoxData.Amt.length > 0) {
        searchBoxData.startAmt = searchBoxData.Amt[0];
        searchBoxData.endAmt = searchBoxData.Amt[1];
        delete searchBoxData.Amt;
      }

      this.$refs.tableBox.saveSearchBoxData({
        '_GRID_TYPE': 'jq',
        // 科目类型：1.申请 2.报销
        subjectsType: 2,
        ...searchBoxData,
      });
    },
  },

  async created () {
    const enumsList = await getEnumList({
      codeType: 'PAYMANAGER_STATE',
    });
    this.searchBoxData.stateOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...enumsList[0],
    ];
    const orgIdOptions = await getDepartmentAllList();
    this.searchBoxData.orgIdOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...orgIdOptions,
    ];
    const payTypeNameOptions = await queryManagerTypes({
      subjectsType: 2,
    });
    this.searchBoxData.payTypeNameOptions = [
      {
        label: '全部',
        value: 0,
      },
      ...payTypeNameOptions,
    ];
    this.jumpHereSearchState();
  },
  activated () {
    // 第一次进入
    const state = this.$route.query.state;
    if (state) {
      this.$refs.searchBox.setVal('state', state);
    }

    const waitDeal = this.$route.query.waitDeal;
    if (waitDeal) {
      this.$refs.searchBox.setVal('waitDeal', true);
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .next-search-btn {
  position: absolute;
  left: calc(100% - 315px);
  top: 110px;
  width: 100px !important;
}
</style>
